import { makeStyles } from "@mui/styles";

export const useStyle = makeStyles((theme) => ({
  mainGrid: {
    "&.MuiGrid-root": {
        backgroundColor:'white',
        width:'100%',
        maxWidth:'420px',
        padding:'25px',
        height:'fit-content',
        borderRadius:'5px',
        boxShadow:'2px 0px 18px -1px rgba(0,0,0,0.34)'
    },
  },
  logo:{
    '&.MuiAvatar-root':{
      margin:'0 auto',
      width:'240px',
      height:'auto',
    }
  }
}));